// // QrGenerator.js
// import React, { useEffect, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";
// import QRCodeStyling from "qr-code-styling";
// import logo from "./logo1.png"; // Make sure this logo has a transparent background for best results
// import "./QrGenerator.css"; // Import the new CSS file
// import "./global.css";

// const QrGenerator = () => {
//   const location = useLocation();
//   const url = location.state?.url || "";

//   const [fileExt, setFileExt] = useState("png");
//   const qrCodeRef = useRef(null);

//   // Initialize the QR code styling object once
//   const qrCode = useRef(
//     new QRCodeStyling({
//       width: 1000,
//       height: 1000,
//       type: "svg",
//       data: url,
//       image: logo,
//       dotsOptions: {
//         color: "#000000", // Black dots for high contrast
//         type: "rounded",
//       },
//       backgroundOptions: {
//         color: "#ffffff", // Solid white background
//       },
//       imageOptions: {
//         crossOrigin: "anonymous",
//         margin: 15,
//         imageSize: 0.4,
//       },
//     })
//   ).current;

//   // Append the QR code to the DOM
//   useEffect(() => {
//     if (qrCodeRef.current) {
//       qrCode.append(qrCodeRef.current);
//     }
//   }, [qrCode]);

//   // Update the QR code data if the URL changes
//   useEffect(() => {
//     if (url) {
//       qrCode.update({ data: url });
//     }
//   }, [url, qrCode]);

//   const onExtensionChange = (event) => setFileExt(event.target.value);
//   const onDownloadClick = () => qrCode.download({ extension: fileExt , scale:10});

//   return (
//     <div className="qr-page-container">
//       <div className="qr-panel">
//         <h1 className="qr-title">Your QR Code is Ready</h1>
//         <p className="qr-url-label">URL:</p>
//         <p className="qr-url">{url || "⚠️ No URL provided"}</p>

//         <div className="qr-code-container" ref={qrCodeRef} />

//         <div className="qr-controls">
//           <select
//             onChange={onExtensionChange}
//             value={fileExt}
//             className="qr-select"
//           >
//             <option value="png">PNG</option>
//             <option value="jpeg">JPEG</option>
//             <option value="webp">WEBP</option>
//           </select>

//           <button onClick={onDownloadClick} className="qr-download-button">
//             Download
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QrGenerator;


// import React, { useEffect, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";
// import QRCodeStyling from "qr-code-styling";
// import logo from "./logo1.png";
// import "./QrGenerator.css";
// import "./global.css";

// const QrGenerator = () => {
//   const location = useLocation();
//   const url = location.state?.url || "";

//   const [fileExt, setFileExt] = useState("png");
//   const [downloadSize, setDownloadSize] = useState(1000); // default download resolution
//   const qrCodeRef = useRef(null);

//   const previewSize = 300; // 👈 always fixed for preview

//   // QR code instance
//   const qrCode = useRef(
//     new QRCodeStyling({
//       width: previewSize,
//       height: previewSize,
//       type: "svg",
//       data: url,
//       image: logo,
//       dotsOptions: { color: "#000000", type: "rounded" },
//       backgroundOptions: { color: "#ffffff" },
//       imageOptions: { crossOrigin: "anonymous", margin: 15, imageSize: 0.4 },
//     })
//   ).current;

//   // Append QR preview
//   useEffect(() => {
//     if (qrCodeRef.current) {
//       qrCode.append(qrCodeRef.current);
//     }
//   }, [qrCode]);

//   // Update preview on URL change
//   useEffect(() => {
//     if (url) {
//       qrCode.update({ data: url, width: previewSize, height: previewSize });
//     }
//   }, [url, qrCode]);

//   const onExtensionChange = (event) => setFileExt(event.target.value);
//   const onDownloadSizeChange = (event) => setDownloadSize(Number(event.target.value));

//   const onDownloadClick = async () => {
//     // 1. Temporarily resize QR for high-res export
//     await qrCode.update({ width: downloadSize, height: downloadSize });

//     // 2. Download in the chosen format
//     qrCode.download({ extension: fileExt });

//     // 3. Reset back to 300x300 for preview
//     await qrCode.update({ width: previewSize, height: previewSize });
//   };

//   return (
//     <div className="qr-page-container">
//       <div className="qr-panel">
//         <h1 className="qr-title">Your QR Code is Ready</h1>
//         <p className="qr-url-label">URL:</p>
//         <p className="qr-url">{url || "⚠️ No URL provided"}</p>

//         {/* Always shows 300x300 */}
//         <div className="qr-code-container" ref={qrCodeRef} />

//         <div className="qr-controls">
//           {/* File format */}
//           <select
//             onChange={onExtensionChange}
//             value={fileExt}
//             className="qr-select"
//           >
//             <option value="png">PNG</option>
//             <option value="jpeg">JPEG</option>
//             <option value="webp">WEBP</option>
//             <option value="svg">SVG</option>
//           </select>

//           {/* Download size */}
//           <select
//             onChange={onDownloadSizeChange}
//             value={downloadSize}
//             className="qr-select"
//           >
//             <option value={600}>600 × 600</option>
//             <option value={1000}>1000 × 1000</option>
//             <option value={2000}>2000 × 2000</option>
//             <option value={3000}>3000 × 3000</option>
//           </select>

//           <button onClick={onDownloadClick} className="qr-download-button">
//             Download
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QrGenerator;


import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import QRCodeStyling from "qr-code-styling";
import logo from "./logo1.png";
import "./QrGenerator.css";
import "./global.css";

const QrGenerator = () => {
  const location = useLocation();
  const url = location.state?.url || "";

  const [fileExt, setFileExt] = useState("png");
  const [downloadSize, setDownloadSize] = useState(1000); // default download resolution
  const qrCodeRef = useRef(null);

  const previewSize = 300; // 👈 always fixed for preview

  // Preview QR instance (always small)
  const qrCode = useRef(
    new QRCodeStyling({
      width: previewSize,
      height: previewSize,
      type: "svg",
      data: url,
      image: logo,
      dotsOptions: { color: "#000000", type: "rounded" },
      backgroundOptions: { color: "#ffffff" },
      imageOptions: { crossOrigin: "anonymous", margin: 15, imageSize: 0.4 },
    })
  ).current;

  // Append QR preview
  useEffect(() => {
    if (qrCodeRef.current) {
      qrCode.append(qrCodeRef.current);
    }
  }, [qrCode]);

  // Update preview when URL changes
  useEffect(() => {
    if (url) {
      qrCode.update({ data: url });
    }
  }, [url, qrCode]);

  const onExtensionChange = (event) => setFileExt(event.target.value);
  const onDownloadSizeChange = (event) => setDownloadSize(Number(event.target.value));

  const onDownloadClick = async () => {
    // Create a new temporary high-res QR just for download
    const qrCodeDownload = new QRCodeStyling({
      width: downloadSize,
      height: downloadSize,
      type: "svg",
      data: url,
      image: logo,
      dotsOptions: { color: "#000000", type: "rounded" },
      backgroundOptions: { color: "#ffffff" },
      imageOptions: { crossOrigin: "anonymous", margin: 15, imageSize: 0.4 },
    });

    // Trigger download
    qrCodeDownload.download({ extension: fileExt });
  };

  return (
    <div className="qr-page-container">
      <div className="qr-panel">
        <h1 className="qr-title">Your QR Code is Ready</h1>
        <p className="qr-url-label">URL:</p>
        <p className="qr-url">{url || "⚠️ No URL provided"}</p>

        {/* Always shows 300x300 preview */}
        <div className="qr-code-container" ref={qrCodeRef} />

        <div className="qr-controls">
          {/* File format */}
          <select
            onChange={onExtensionChange}
            value={fileExt}
            className="qr-select"
          >
            <option value="png">PNG</option>
            <option value="jpeg">JPEG</option>
            <option value="webp">WEBP</option>
            <option value="svg">SVG</option>
          </select>

          {/* Download size */}
          <select
            onChange={onDownloadSizeChange}
            value={downloadSize}
            className="qr-select"
          >
            <option value={600}>600 × 600</option>
            <option value={1000}>1000 × 1000</option>
            <option value={2000}>2000 × 2000</option>
            <option value={3000}>3000 × 3000</option>
          </select>

          <button onClick={onDownloadClick} className="qr-download-button">
            Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default QrGenerator;
